/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { GeoCitiesByCapResponse } from '../../models/geo-cities-by-cap-response';

export interface GeoControllerGetCitiesByCap$Params {
  cap: string;
}

export function geoControllerGetCitiesByCap(http: HttpClient, rootUrl: string, params: GeoControllerGetCitiesByCap$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: GeoCitiesByCapResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, geoControllerGetCitiesByCap.PATH, 'get');
  if (params) {
    rb.path('cap', params.cap, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: GeoCitiesByCapResponse;
      }>;
    })
  );
}

geoControllerGetCitiesByCap.PATH = '/geo/italy/by-cap/{cap}';
